// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/css/main.120bce64.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"1f42a6a3","393":"334aa36d","774":"b993a222","841":"770cfd04"}[chunkId] + ".chunk.css";
};